export const TagsRoutes = {
  HOME: '/',
  ADD: '/add',
  EDIT: '/edit/:id',
};
